import { sampleBarcodeHorizontalSvg, sampleBarcodeVerticalSvg } from '../../../../backend/features/barcodesAamvaBadge/shared';
export const sampleImageGenerationBarcodeData = {
    barcodeHorizontalSvg: sampleBarcodeHorizontalSvg,
    barcodeVerticalSvg: sampleBarcodeVerticalSvg,
};
